import { System } from 'common/systems/domain/resources/system.resource';

/**
 * Read/write port for the live `SystemsState` of the `systems` capability,
 * mirroring the role of `ActiveDealsBagPort`
 * (`common/deals-bag/application/ports/active-deals-bag.port.ts`).
 * Implementations live in the UI/infrastructure layer (`SystemsStoreAdapter`,
 * wrapping the actual owner of the state, `SystemsStore`); domain and
 * Facade consumers must depend only on this abstract class, never on a
 * concrete framework state container.
 */
export abstract class SystemsStatePort {
    public abstract getAll(): ReadonlyArray<System>;

    public abstract getById(id: string): System | undefined;

    public abstract applyUpdate(updatedSystems: ReadonlyArray<System>): void;
}
